export default __webpack_public_path__ + "static/media/portaplasticos.473e5977.png";